import { IconSVG } from '../types';

export const Camera = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 -960 960 960"
      style={style}
    >
      <path d="M480-260q75 0 127.5-52.5T660-440t-52.5-127.5T480-620t-127.5 52.5T300-440t52.5 127.5T480-260m0-80q-42 0-71-29t-29-71 29-71 71-29 71 29 29 71-29 71-71 29M160-120q-33 0-56.5-23.5T80-200v-480q0-33 23.5-56.5T160-760h126l74-80h240l74 80h126q33 0 56.5 23.5T880-680v480q0 33-23.5 56.5T800-120zm0-80h640v-480H638l-73-80H395l-73 80H160zm320-240" />
    </svg>
  );
};
